export default "__VITE_ASSET__DP23GQOl__"